export const MainWindowsCleaning = {
    "imageUrl": "/assets/imgs/services/11WindowsCleaning/fondo.png",
    "eyebrow": "Windows",
    "title": "Cleaning",
    "headingSpan": "CRYSTAL CLEAR VIEWS,",
    "heading": "EVERY TIME",
    "description": "Over time, dirt, grime, and environmental pollutants can dull the appearance of your building’s windows, affecting both aesthetics and natural light. At HRD Painting & Restoration, we provide professional high-rise and commercial window cleaning to ensure your property maintains a pristine, polished look while enhancing visibility and curb appeal.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};